import { Play, Heart, PlusCircle } from "@phosphor-icons/react";
import { TEST_IDS } from "@/constants/testIds";

export default function VideoCard({ video, onPlay, onFav, isFav, onAddToPlaylist }) {
  return (
    <div data-testid={TEST_IDS.video.card} className="group glass-card overflow-hidden hover:border-cyan-300/30 hover:-translate-y-1 transition-all duration-200">
      <div className="relative aspect-video bg-[#07111d] overflow-hidden">
        <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover opacity-88 group-hover:opacity-100 transition-opacity" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
        <button
          data-testid={TEST_IDS.video.playBtn}
          onClick={() => onPlay(video)}
          className="absolute inset-0 flex items-center justify-center"
          aria-label="Play"
        >
          <div className="w-14 h-14 rounded-full border border-white/30 bg-black/40 backdrop-blur flex items-center justify-center text-white group-hover:bg-[#ff4d1d] group-hover:border-[#ff4d1d] transition-colors shadow-[0_0_26px_rgba(0,0,0,.36)]">
            <Play size={22} weight="fill" />
          </div>
        </button>
      </div>

      <div className="p-4">
        <h3 className="font-serif-display text-lg font-semibold leading-tight mb-2 line-clamp-2 min-h-[3rem] text-white">
          {video.title}
        </h3>
        <div className="font-mono text-[10px] uppercase tracking-[0.13em] text-slate-400 mb-3 truncate">
          {video.channel}
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => onPlay(video)}
            className="flex-1 py-2.5 rounded-2xl border border-[#09e7ff]/40 bg-[#09e7ff]/10 text-cyan-300 hover:bg-[#09e7ff] hover:text-[#05070d] transition-colors font-mono text-[10px] uppercase tracking-[0.16em] flex items-center justify-center gap-1.5"
          >
            <Play size={12} weight="fill" /> Play
          </button>
          {onFav && (
            <button
              data-testid={TEST_IDS.video.favBtn}
              onClick={() => onFav(video)}
              className={`w-10 h-10 rounded-full border flex items-center justify-center transition-colors ${isFav ? "border-[#ff4d1d]/60 text-[#ff4d1d] bg-[#ff4d1d]/10" : "border-white/10 text-slate-300/60 hover:border-[#ff4d1d]/60 hover:text-[#ff4d1d]"}`}
              aria-label="Favorite"
            >
              <Heart size={14} weight={isFav ? "fill" : "regular"} />
            </button>
          )}
          {onAddToPlaylist && (
            <button
              data-testid={TEST_IDS.video.addPlaylistBtn}
              onClick={() => onAddToPlaylist(video)}
              className="w-10 h-10 rounded-full border border-white/10 text-slate-300/60 hover:border-cyan-300/60 hover:text-cyan-300 flex items-center justify-center transition-colors"
              aria-label="Add to playlist"
            >
              <PlusCircle size={16} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
